module.exports = __webpack_public_path__ + "static/media/CV-Paul-Dickerson.58867b52.pdf";